import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import Paginate from 'react-paginate'
import { observer } from 'mobx-react'

import * as h from 'h'

import ResultBox from 'components/ResultBox'
import ResultsIndicator from 'components/ResultsIndicator'

import styles from './styles.scss'

@observer(['UiStore'])
export default class Results extends React.Component {
  get pagination () {
    return this.props.UiStore.pagination
  }

  onPageClick ({ selected }) {
    const { UiStore, onPageClick } = this.props

    // correct zero-indexing
    const current = selected + 1

    // update ui store
    UiStore.setCurrentPage(current)

    // forward to parent
    if (onPageClick) {
      onPageClick(current)
    }
  }

  render () {
    const {
      elements,
      isRequesting,
      resultComponent,
      hideResultsUntilFinishedRequesting
    } = this.props

    const showResults = hideResultsUntilFinishedRequesting ? !isRequesting : true

    return h.div(null,
      showResults && h.h(CSSTransitionGroup, {
        className: 'clearfix',
        transitionName: 'result-box-transitioner',
        transitionAppear: true,
        // for some reason, even though the transition is 300ms
        // it isn't working with a timeout of 300.
        transitionAppearTimeout: 500,
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 500,
        children: elements.map(el => React.isValidElement(el)
          ? el
          : h.h(resultComponent || ResultBox, {
            key: el.id,
            element: el
          }))
      }),
      h.h(ResultsIndicator, {
        showProgress: isRequesting,
        hasResults: elements.length > 0
      }),
      h.maybe(this.pagination.last > 0,
        h.h(Paginate, {
          pageNum: this.pagination.last,
          forceSelected: this.pagination.current - 1, // corrent zero-indexing
          pageRangeDisplayed: 2,
          marginPagesDisplayed: 2,
          clickCallback: ::this.onPageClick,
          breakLabel: h.span(h.ca(styles.paginatorBreakLabel), '…'),
          containerClassName: styles.paginator,
          activeClassName: styles.paginatorActiveItem,
          disabledClassName: styles.paginatorDisabledItem
        })))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Results/index.js